import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { useDrawerAskAI } from 'tripPlanner/pages/chat/ChatTripPlannerPage/hooks/useDrawerAskAI'
import { useDrawerAskAIChatState } from 'tripPlanner/pages/chat/ChatTripPlannerPage/contexts/DrawerAskAIContext'
import DrawerAskAIInput from './DrawerAskAIInput'
import DrawerAskAIBubble from './DrawerAskAIBubble'

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: ${rem(12)} ${rem(24)} calc(${rem(16)} + env(safe-area-inset-bottom, 0px));
  gap: ${rem(8)};
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
  width: 100%;
  max-width: ${rem(652)};
  min-width: 0;
`

interface Props {
  contextLabel: string
  isOpen: boolean
  /** Formatted drawer details to include as context when asking from a drawer. */
  contextDetails?: string
  placeholder?: string
}

function DrawerAskAIFooter({
  contextLabel,
  isOpen,
  contextDetails,
  placeholder,
}: Props) {
  const intl = useIntl()
  const { submitMessage, messages, isStreaming } = useDrawerAskAIChatState()

  const {
    handleSubmit,
    latestResponse,
    sessionHistory,
    isResponseStreaming,
    isWaitingForResponse,
    hasActiveSession,
  } = useDrawerAskAI({
    submitMessage,
    messages,
    isStreaming,
    contextLabel,
    isOpen,
    contextDetails,
  })

  return (
    <FooterContainer>
      {hasActiveSession && (
        <ContentWrapper>
          <DrawerAskAIBubble
            latestResponse={latestResponse}
            sessionHistory={sessionHistory}
            isResponseStreaming={isResponseStreaming}
            isWaitingForResponse={isWaitingForResponse}
          />
        </ContentWrapper>
      )}
      <DrawerAskAIInput
        onSubmit={handleSubmit}
        disabled={isStreaming}
        placeholder={placeholder ?? intl.formatMessage(
          {
            id: 'johNJoOJenxVY0dTszC9',
            defaultMessage: 'Ask me anything about {contextLabel}',
            description: 'Placeholder text for AI assistant input field with context about current item',
          },
          { contextLabel },
        )}
        hasActiveSession={hasActiveSession}
        forceExpanded
      />
    </FooterContainer>
  )
}

DrawerAskAIFooter.displayName = 'DrawerAskAIFooter'

export default DrawerAskAIFooter
